/**
 * @author: Ashay Tiwari
 * @date: 12 Aug 2021
 * @description: File for Chat Action Types
 * @developedBy: Kritin Digital Solutions Pvt. Ltd.
 */
export const SHOW_USER_CHAT_HISTORY = "SHOW_USER_CHAT_HISTORY";
export const SHOW_USER_COMMUNICATED_LIST = "SHOW_USER_COMMUNICATED_LIST";
